export function formatStr(string) {
  let out = string.toLowerCase();
  out = out.replaceAll(' ', '-');
  return out;
}

export function formatIncome(num) {
  let out = Math.round(num / 1000);
  out = `${out}K`;
  return out;
}
